import { Component } from '@angular/core';
import { AsyncPipe, NgClass, NgIf } from '@angular/common';
import { LocalstorageService } from '../../services/localstorage.service';
import { RouterLink } from '@angular/router';
import { ConfigRepository } from '../../repositories/config.repository';
import { map } from 'rxjs';

@Component({
  selector: 'app-cookies-alert',
  templateUrl: './cookies-alert.component.html',
  styleUrls: ['./cookies-alert.component.scss'],
  standalone: true,
  imports: [NgIf, NgClass, RouterLink, AsyncPipe]
})
export class CookiesAlertComponent {
  constructor(
    private localStorage: LocalstorageService,
    private configRepository: ConfigRepository,
  ) {}

  hideExpansion: boolean = true;
  hideExpansionClass: boolean = true;

  onCloseModal: boolean = false;
  personalDataPolicyLink$ = this.configRepository.personalDataPolicyPage$.pipe(
    map(page => !!page ? '/additional/personal-data-policy' : '/additional/privacy-policy')
  );

  onShowMore(): void {
    this.hideExpansion = !this.hideExpansion;
    setTimeout(() => {
      this.hideExpansionClass = !this.hideExpansionClass;
    }, 150);
  }

  onClose(): void {
    this.localStorage.set('cookiesModal', '1');
    this.onCloseModal = true;
  }
}
